module.exports = __webpack_public_path__ + "assets/f4cee93d32bbb6518e1f6958b8f41581.png";